import { useState } from "react";
import { useSelector } from "react-redux";
import { Grid, TextField, Card, DialogTitle, DialogContent, IconButton, Typography, DialogActions } from "@mui/material";
// icons
import { grey } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { numberOnly } from "utilities/common";
import { validateKitProductsBulkQty } from "validations/hyperwolf/distributionmanagement";
// custom components
import MDButton from "components/MDButton";

export default function AssignQtyToBox({ closeModal }) {
    const { modalData } = useSelector(state => state.modal || {});
    const { box, setSelectedBoxes = () => { }, setSelectedBulkQuantity = () => { } } = modalData || {};

    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;

        setValues(prev => ({ ...prev, [name]: numberOnly(value) }));
    }

    const handleSave = async () => {
        const { myErrors, isValid } = validateKitProductsBulkQty(values)

        if (!isValid) {
            setErrors(myErrors);
            return;
        } else {
            setErrors({});
        }

        if (box) {
            setSelectedBoxes(prev => {
                const updatedBoxes = [...(prev || [])];
                const index = updatedBoxes.findIndex(item => item.boxId === box._id);

                if (index !== -1) {
                    updatedBoxes[index] = { ...values, boxId: box._id };
                } else {
                    updatedBoxes.push({ ...values, boxId: box._id });
                }

                return updatedBoxes;
            });
        } else {
            setSelectedBulkQuantity(values);
        }

        closeModal();
    };

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
                Assign Qty To {box?.name || "All Products"}
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Min Quantity</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            className="form-input created-by p-l-field bg-transparent"
                            name="minQuantity"
                            value={values?.minQuantity || ""}
                            onChange={handleChange}
                        />
                        {errors?.minQuantity && <p className="error">{errors?.minQuantity}</p>}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Max Quantity</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            className="form-input created-by p-l-field bg-transparent"
                            name="maxQuantity"
                            value={values?.maxQuantity || ""}
                            onChange={handleChange}
                        />
                        {errors?.maxQuantity && <p className="error">{errors?.maxQuantity}</p>}
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions style={{ justifyContent: "center" }}>
                <MDButton
                    color="primary"
                    type="button"
                    variant="contained"
                    onClick={handleSave}
                >
                    Save
                </MDButton>
                <MDButton
                    onClick={closeModal}
                    type='button'
                    variant='outlined'
                    color='dark'
                >
                    Cancel
                </MDButton>
            </DialogActions>
        </Card>
    )
}